// @ts-ignore
import AnalyticsWebClient from '@atlassiansox/analytics-web-client';
import Loadable from 'react-loadable';

export interface XFlowProps {
  analyticsClient: AnalyticsWebClient;
  cloudId: string;
  edition?: string;
  instanceName: string;
  isCrossSell: boolean;
  isEnrolledInExpandDiscovery: boolean;
  migrationSourceUuid?: string;
  onAnalyticsEvent: (event: string, attrs: object) => void;
  onComplete: () => void;
  onError?: () => void;
  sourceComponent: string;
  sourceContext: string;
  targetProduct: string;
}

export function XFlowLoading({ error }: LoadableExport.LoadingComponentProps): null {
  if (error) {
    // Propagate the error to the error boundary
    throw error;
  }
  return null;
}

const XFlowLazy = Loadable<XFlowProps, {}>({
  loader: () => import(/* webpackChunkName: "xflow" */ '@atlassiansox/xflow-ui'),
  loading: XFlowLoading,
});

export const XFlowIFrameLazy = Loadable<XFlowProps, {}>({
  loader: () => import(/* webpackChunkName: "xflowiframe" */ './XflowIFrame'),
  loading: XFlowLoading,
});

export default XFlowLazy;
